import React, { useContext, useEffect, useState } from 'react';
import { OptionsProps } from './interface';
import {
  Welcome,
  OptionCard,
  OptionIcon,
  OptionContent,
  OptionTitle,
  OptionDescription,
  RadioCircle,
} from './Elements';
import { FormattedMessage } from 'react-intl';
import {
  minipodIcon,
  cameraIcon,
  archTypeIcon
} from '../../assets/Images';
import Events from './Events';
import {
  FOOT_ARCH_OPTION,
} from '../../interfaces/ProductService.interface';
import { ShopSettingsContext } from '../../FootprintTech/AppController';
import { Button } from '../Common/Button';

export function MeasureOptions(props: OptionsProps) {

  const { emitter } = props;
  const shopSettings = useContext(ShopSettingsContext);
  const [ selectedOption, setSelectedOption ] = useState('');
  const [ continueEnabled, setContinueEnabled ] = useState(false);

  const handleMinipodSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(FOOT_ARCH_OPTION.MC);
    emitter.emit(Events.onMeasureOptionSelect, FOOT_ARCH_OPTION.MC);
    setContinueEnabled(true);
  };

  const handlePiSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(FOOT_ARCH_OPTION.PI);
    emitter.emit(Events.onMeasureOptionSelect, FOOT_ARCH_OPTION.PI);
    setContinueEnabled(true);
  };

  const handleManualSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(FOOT_ARCH_OPTION.NONE);
    emitter.emit(Events.onMeasureOptionSelect, FOOT_ARCH_OPTION.NONE);
    setContinueEnabled(true);
  };

  const handleMobileSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(FOOT_ARCH_OPTION.FPT);
    emitter.emit(Events.onMeasureOptionSelect, FOOT_ARCH_OPTION.FPT);
    setContinueEnabled(true);
  };

  const handleContinue = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    console.log('continue clicked');
    emitter.emit(Events.onMeasureOptionConfirm, selectedOption);
    emitter.emit(Events.onContinuePress);
  }

  return(
    <>
      <Welcome>
        <FormattedMessage
          id="lp.hartmann.input-selection.title"
          values={{
            br: <br />,
          }}
        />
      </Welcome>
    { shopSettings.mcEnabled &&
            <OptionCard
              id="option-minipod"
              onClick={handleMinipodSelect}
              className={selectedOption === FOOT_ARCH_OPTION.MC ? 'selected' : ''}
            >
                <OptionIcon src={minipodIcon} alt="Minipod"/>
                <OptionContent>
                  <OptionTitle>
                    <FormattedMessage id="lp.hartmann.input-selection.option.minipod.title" />
                  </OptionTitle>
                  <OptionDescription>
                    <FormattedMessage id="lp.hartmann.input-selection.option.minipod.description" />
                  </OptionDescription>
                </OptionContent>
                <RadioCircle className="radio-circle" />
            </OptionCard>
    }
    { shopSettings.insoleAvailable &&
            <OptionCard
              id="option-pi"
              onClick={handlePiSelect}
              className={selectedOption === FOOT_ARCH_OPTION.PI ? 'selected' : ''}
            >
                <OptionIcon src={minipodIcon} alt="Plantar Image"/>
                <OptionContent>
                  <OptionTitle>
                    <FormattedMessage id="drv.input-selection.option.pi.title" />
                  </OptionTitle>
                  <OptionDescription>
                    <FormattedMessage id="drv.input-selection.option.pi.description" />
                  </OptionDescription>
                </OptionContent>
                <RadioCircle className="radio-circle" />
            </OptionCard>
    }

            <OptionCard
              id="option-mobile"
              onClick={handleMobileSelect}
              className={selectedOption === FOOT_ARCH_OPTION.FPT ? 'selected' : ''}
            >
                <OptionIcon src={archTypeIcon} alt="Mobile"/>
                <OptionContent>
                  <OptionTitle>
                  <FormattedMessage id="lp.hartmann.input-selection.option.mobile.title" />
                  </OptionTitle>
                  <OptionDescription>
                  <FormattedMessage id="lp.hartmann.input-selection.option.mobile.description" />
                  </OptionDescription>
                </OptionContent>
                <RadioCircle className="radio-circle" />
            </OptionCard>

            <OptionCard
              id="option-manual"
              onClick={handleManualSelect}
              className={selectedOption === FOOT_ARCH_OPTION.NONE ? 'selected' : ''}
            >
                <OptionIcon src={cameraIcon} alt="Minipod"/>
                <OptionContent>
                  <OptionTitle>
                    <FormattedMessage id="lp.hartmann.input-selection.option.skip-arch-measurement.title" />
                  </OptionTitle>
                  <OptionDescription>
                    <FormattedMessage id="lp.hartmann.input-selection.option.skip-arch-measurement.description" />
                  </OptionDescription>
                </OptionContent>
                <RadioCircle className="radio-circle" />
            </OptionCard>
            <Button
              disabled={ continueEnabled ? false : true }
              onClick={handleContinue} type="button"
              className="wide-primary">
              <FormattedMessage id="lp.hartmann.input-selection.continue" />
            </Button>
    </>
  )
}
